import { VideoPlayer } from "@modules/common/media/components/videoPlayer"
import { word } from "@modules/core/utils/i18n"
import { Media } from "@modules/sessionBlock/media/mediaTypes"
import { HUText } from "@modules/ui/components/huText"
import { ComponentProps } from "react"

type MediaDetailsVideoProps = {
  media: Media
} & ComponentProps<"div">

export function MediaDetailsVideo({ media, ...props }: MediaDetailsVideoProps) {
  return (
    <div {...props}>
      {media.url ? (
        <VideoPlayer
          options={{
            autoplay: false,
            controls: true,
            experimentalSvgIcons: true,
            sources: [
              {
                src: media.url,
                type: "application/x-mpegURL",
              },
            ],
          }}
          size="medium"
          className="rounded-big-radius overflow-hidden"
        />
      ) : (
        <HUText fontStyle="BM" style={{ overflowWrap: "break-word" }}>
          {word("sessionForm.blocks.add_media.missing_error")}
        </HUText>
      )}
    </div>
  )
}
